/* eslint-disable */
export default {
  contactDetails: 'Kontaktdetails',
  loadingContact: 'Kontakt wird geladen...',
  contactNotFound: 'Kontakt nicht gefunden.',
} as const;

// @key: @#@"contactDetails"@#@ @source: @#@"Contact Details"@#@
// @key: @#@"loadingContact"@#@ @source: @#@"Loading contact..."@#@
// @key: @#@"contactNotFound"@#@ @source: @#@"Contact not found."@#@
